/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { Injectable } from '@angular/core';
import { login, logout } from '@app/core/ngrx/actions';
import { WebSocketConnection } from '@app/core/services/websocket-connection.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs/operators';

@Injectable()
export class WebSocketEffects {
  constructor(
    private actions$: Actions,
    private ws: WebSocketConnection,
  ) {}

  activate$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(login),
        tap(() => this.ws.activate()),
      ),
    { dispatch: false },
  );

  deactivate$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(logout),
        tap(() => this.ws.deactivate()),
      ),
    { dispatch: false },
  );
}
